module.exports = __webpack_public_path__ + "static/media/trolleybus.81324a38.svg";